import styled from "@emotion/styled";

import { fontMerriweather, fontRoboto } from "shared/lib/styles";

import QuoteIcon from "scmp-app/components/schema-render/common/blockquote-quote/icon-quote.svg";

export const Container = styled.figure`
  display: flex;
  flex-direction: column;

  color: #000000;
`;

export const StyledQuoteIcon = styled(QuoteIcon)`
  inline-size: 36px;
  block-size: 36px;
  padding-inline: 3px;
`;

export const Blockquote = styled.blockquote`
  font-weight: 900;
  font-size: 14px;
  font-family: ${fontMerriweather};
  line-height: 17.6px;
`;

export const Figcaption = styled.figcaption`
  margin-block-start: 4px;

  font-weight: 900;
  font-size: 12px;
  font-family: ${fontRoboto};
  line-height: 14px;
`;
